module.exports = __webpack_public_path__ + "img/certificate_2.791c81a0.jpeg";